<template>
    <div class="inner-wrap">
        <div v-show="isDataLoading" style="padding: 256px;">
            <loading-progress :running="isDataLoading"></loading-progress>
        </div>

        <div class="info-data" v-if="isNotEmpty(baseInfo)">
            <dl>
                <dt>시작일</dt>
                <dd v-html="eventStartDate"></dd>
            </dl>
            <dl>
                <dt>종료일</dt>
                <dd v-html="eventEndDate"></dd>
            </dl>
            <dl>
                <dt>전화번호</dt>
                <dd v-html="ifNullProp(baseInfo,'tel', '&nbsp;')"></dd>
            </dl>
            <dl>
                <dt>주소</dt>
                <dd v-html="eventAddress"></dd>
            </dl>
            <dl>
                <dt>주최</dt>
                <dd v-html="ifNullProp(detailIntro,'sponsor1', '&nbsp;')"></dd>
            </dl>
            <dl>
                <dt>주관</dt>
                <dd v-html="ifNullProp(detailIntro,'sponsor2', '&nbsp;')"></dd>
            </dl>
            <dl class="last">
                <dt>홈페이지</dt>
                <dd v-if="isEmpty(baseInfo.homepage)">&nbsp;</dd>
                <dd v-else><a :href="baseInfo.homepage" v-html="baseInfo.homepage" target="_blank"></a></dd>
            </dl>
        </div>

        <p class="text" v-if="isNotEmpty(detailInfo)" v-html="ifNullProp(detailInfo, 'infotext', '&nbsp;')"></p>
        <!--<p class="text" v-for="(detail, index) in detailInfo" v-html="detail.infotext" :key="index"></p>-->

        <info-additional
            :detail-intro="detailIntro"
        ></info-additional>

        <!--TODO : 지도 오류로 일시적으로 숨기기-->
        <!--<info-location-->
            <!--:lat="37.3595316"-->
            <!--:lng="127.1052133"-->
            <!--address=" "-->
        <!--&gt;</info-location>-->

        <info-image
            v-if="isNotEmptyProp(imageData, 'count') && imageData.count>0"
            :first-image-url="firstImageUrl()"
            :image-data="imageData"
        ></info-image>
        
    </div>
</template>

<script>
import InfoAdditional from './InfoAdditional.vue';
import InfoLocation from './InfoLocation.vue';
import InfoImage from './InfoImage.vue';

import LoadingProgress from '../../components/Shared/LoadingProgress.vue'; // 로딩 프로그래스바

export default {
    components: {
        InfoAdditional, // <info-additional>
        InfoLocation, // <info-location>
        InfoImage, // <info-image>
        LoadingProgress, // <loading-progress>
    },
    props: {
        contentId: { type: Number, required: true }, 
        apiUrl: { type: String, required: true }, 
    },
    data() {
        return {
            isDataLoading: true, // 초기 데이터 로딩 여부
            baseInfo: {},
            detailIntro: {},
            detailInfo: [],
            imageData: {
                count: 0,
                pages: 1,
                pagePerImage: 4,
                images: [],
            },
        }
    },
    computed: {
        eventStartDate() {
            return this.isNotEmptyProp(this.detailIntro, 'eventstartdate')?this.formatDate(this.detailIntro.eventstartdate):'';
        },
        eventEndDate() {
            return this.isNotEmptyProp(this.detailIntro, 'eventenddate')?this.formatDate(this.detailIntro.eventenddate):'';
        },
        eventAddress() {
            return this.ifNull(this.baseInfo.addr1, '&nbsp;')
                + ' ' + this.ifNull(this.baseInfo.addr2, '&nbsp;');
        },
    },
    created() {
        this.getData();
//        this.$log('오류감지 테스트');
    },
    methods: {
        getData() {
            const apiUrl = 
                this.urlPrefix + // [DEBUG]
                '/api/v1/festival/' + this.contentId
            ;
            // const apiUrl = 'https://ncms-test.nculture.org/api/v1/festival/910544'; // [DEBUG]
            axios.get(apiUrl).then(({data}) => { // console.log(data);
                this.baseInfo = data.base;
                this.detailIntro = data.detail_intro;
                this.detailInfo = data.detail_info;
                this.imageData = data.image_data;
                // this.$forceUpdate();

                // this.generateSlide();
                // this.initSlide();
            }).catch(err => {
                console.log(err);
            }).finally(()=>{
                this.isDataLoading = false;
            });
        },
        formatDate(strDate) {
            if (typeof strDate != 'undefined') {
                return strDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1.$2.$3');
            }
            return '&nbsp;';
        },        
        firstImageUrl() {
            if( this.isNotEmptyProp(this.imageData, 'images') ){
                for(var index in this.imageData.images) {
                    return this.imageData.images[index].originimgurl;
                }
            }else return '';
        },
        
    }
}
</script>